let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cq8JU")).then(() => parcelRequire('gB7iw'));